import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppService } from 'src/app/core/services/app.service';
import { FocusdataService } from 'src/app/core/services/focusdata.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { AppMessageSeverity } from 'src/app/shared/models/enums/AppMessageSeverity.enum';
import { License } from 'src/app/shared/models/license.model';

@Component({
	selector: 'app-on-device-setup',
	templateUrl: './on-device-setup.component.html',
	styleUrls: ['../../../../commandcenter.scss'],
})
export class OnDeviceSetupComponent implements OnInit {
	@Input() onDevice: License;
	@Output() onDeviceChange = new EventEmitter<License>();

	licenseList: License[] = [];

	changesToSave: boolean = false;

	constructor(public app: AppService, private focuslink: FocuslinkService, private focusdata: FocusdataService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		this.licenseList = this.venueService.subscriptionVenue.value.licenses.filter((i) => i.type === 'on-device');
		this.venueService.focusPayDeviceGet(this.venueService.subscriptionVenue.value.key);
		if (this.venueService.employeeList.value?.length === 0) {
			this.app.loading(true);
			this.venueService.employeeList.next([]);
			this.venueService.employeeListGet(this.venueService.subscriptionVenue.value.key);
			this.app.loading(false);
		}
	}

	onSave() {
		this.focuslink.licensePut(this.onDevice);
		this.changesToSave = false;
		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: '', detail: `FocusON Settings Saved Successfully` });
	}

	releaseLicense() {
		this.app.confirmation.confirm({
			message: `Are you sure you want to release license ${this.onDevice.key}?`,
			accept: async () => {
				this.onDevice.claimed = false;
				this.onDevice.mac = null;
				this.onDevice.name = 'Unassigned';
				this.onDevice.deviceType = null;
				this.onDevice.softwareVersion = null;
				this.onDevice.printerId = null;
				this.onDevice.stationId = null;
				this.onDevice.updated = new Date();
				this.onDevice.lastUsed = null;
				await this.focuslink.licensePut(this.onDevice);
				const existingKey = this.licenseList.findIndex((i) => i.key === this.onDevice.key);
				this.licenseList[existingKey] = this.onDevice;
				this.onDeviceChange.emit(undefined);
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}
}
